export const FETCH_UPDATE_PROJECT_SETTINGS_REQUEST = 'FETCH_UPDATE_PROJECT_SETTINGS_REQUEST'
export const FETCH_UPDATE_PROJECT_SETTINGS_SUCCESS = 'FETCH_UPDATE_PROJECT_SETTINGS_SUCCESS'
export const FETCH_UPDATE_PROJECT_SETTINGS_FALUIRE = 'FETCH_UPDATE_PROJECT_SETTINGS_FALUIRE'

